<template>
  <div class="main-wrap" @click="hideDropList">
    <div class="list">
      <div
        class="item"
        v-for="(item, index) in blockList"
        :key="index"
        @click="handleClick(item)"
      >
        <img :src="item.img" alt="" />
        <p>{{ item.text }}</p>
      </div>
    </div>
    <template v-if="!isLoading && info">
      <template v-if="info.teamId == 0">
        <div class="guide-wrap">
          <img src="../../assets/images/winterGame/guide_icon.png" alt="" />
          <p>还未组建战队，快去组建吧！</p>
        </div>
      </template>
      <template>
        <div class="team-msg">
          <div class="team-name">{{ info.teamName }}</div>
          <div class="server-center-name">{{ info.servicePointName }}</div>
        </div>
        <section
          class="signOk spring_2025"
          v-if="shouldShowMatchMsg && info.teamId"
        >
          <header>
            <titleBar
              :title="filteredCupName"
            />
          </header>
        </section>
        <div v-else-if="!shouldShowMatchMsg && info.teamId" class="math-period">
          {{ filteredCupName }}
        </div>
        <!-- 新增奖金展示 20240304产品说要隐藏点券入口 end -->
        <!-- 报名状态展示 -->
        <div class="match-msg" v-if="shouldShowMatchMsg && info.teamId">
          <!-- 未报名状态 -->
          <template v-if="!isSignedUp">
            <p class="status">未报名</p>
          </template>
          <!-- 已报名状态 -->
          <template v-else>
            <!-- 报名成功提示 -->
            <section class="signOk">
              <img
                class="sign-up-img"
                src="../../assets/images/squirrelCup/2023/summer/ok.png"
              />
              <p>报名成功</p>
            </section>
            <!-- 报名成功但未提交名单 -->
            <div v-if="!warStatus" class="status">
              请尽快提交
              <span class="view-member" @click="toMembers">出战名单</span>
            </div>
          </template>
        </div>
        <div
          class="banner"
          v-if="!isLoading && info.teamId > 0 && info.payStatus == 0"
        >
          <!--如果创建了团队，且不在比赛期才显示banner 位  // cupStatus(赛季状态) 0未开始/1报名期/2比赛中/3已结束 -->
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(item, index) in bannerList" :key="index">
              <img @click="toDetail(item)" :src="item.photo" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!--历史赛季-->
        <div
          class="history-msg"
          v-if="
            !isLoading &&
            ((signShow && historyList.length > 0) ||
              (cupStatus != 0 && historyList.length > 0)) && false
          "
        >
          <div class="title">历史赛季</div>
          <div
            @click="toHistoryResult(item)"
            class="item"
            v-for="(item, index) in historyList"
            :key="index"
          >
            {{ item.cupName }}
            <van-icon color="#BBBBBB" name="arrow" />
          </div>
        </div>
      </template>
    </template>
    <!-- 战队首页内容-->
    <div
      class="myTeamRecord"
      v-if="
        !isLoading &&
        signShow &&
        info.payStatus == 1 &&
        info.teamMemberStatus == 1
      "
    >
      <section v-if="(cupStatus == 2 || cupStatus == 4 && warStatus == 1) && teamScheduleData.schedule_tag_id">
        <header>
          <titleBar title="战队赛程" />
        </header>
        <main>
          <schedule
            :padTeamId="padTeamId"
            :scheduleData="teamScheduleData"
            :isShowMore="true"
            :gameType="gameType2"
            :isOut="isOut"
            :drawStatus="drawStatus"
            :isDrawed="isDrawed"
            :drawDate="drawDate"
            :drawEndTime="drawEndTime"
            :agentGroupTeamBy="agentGroupTeamBy"
            @toDrawLots="toDrawLots"
          />
        </main>
      </section>
      <section v-show="teamRecordData && teamRecordData.length">
        <header>
          <titleBar title="战队战绩" />
        </header>
        <footer v-if="teamRecordData && teamRecordData.length">
          <teamRecordList
            :teamRecordData="teamRecordData"
            :teamInfo="teamInfo"
            @shareClick="lookBattleReportPoster"
          />
        </footer>
        <footer v-if="teamRecordDataLength > 2">
          <a @click="toMoreRecord" class="more" tag="a"
            >查看全部>
          </a>
        </footer>
      </section>
      <section v-if="honorList.length > 0">
        <header>
          <titleBar title="战队荣誉" />
        </header>
        <div class="list">
          <div class="item" v-for="(item, index) in honorList" :key="index">
            <honorModule
              :honorData="item"
              @shareClick="shareClick"
              :cupYearSeason="teamInfo?.cupYearSeason"
              :numbers="'zhanduirongyu' + index"
            />
          </div>
        </div>
        <footer v-if="honorListLength > 3">
          <router-link to="/winterGame/moreHonor" class="more" tag="a"
            >查看更多战队荣誉>
          </router-link>
        </footer>
      </section>
    </div>
    <van-popup style="width: 100%" v-model="isShowStarMemberPopUpDialog">
      <battalionPoster
        :posterUrl="starMemberPoster.posterUrl"
        :isShow="starMemberPoster.isShow"
        @OnCancelPoster="handleCancelStarMemberPoster"
      >
        <div id="starMemberPosterContainer">
          <star-member
            :isMVP="true"
            :teamInfo="teamInfo"
            :posterData="starMemberPosterData"
            v-if="starMemberPoster.isPoster == 1"
          ></star-member>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="teamHonorPoster.posterUrl"
        :isShow="teamHonorPoster.isShow"
        @OnCancelPoster="handleCancelTeamHonorPoster"
      >
        <div id="teamHonorPosterContainer">
          <team-honor
            :teamInfo="teamInfo"
            :posterData="teamHonorPosterData"
            v-if="teamHonorPoster.isPoster == 1"
          ></team-honor>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup
      style="width: 100%"
      v-model="isShowBattleReportPosterPopUpDialog"
    >
      <battalionPoster
        :posterUrl="battleReportPoster.posterUrl"
        :isShow="battleReportPoster.isShow"
        @OnCancelPoster="handleCancelBattleReportPoster"
      >
        <div id="battleReportPosterContainer">
          <battle-report
            :teamInfo="teamInfo"
            :posterData="battleReportPosterData"
            v-if="battleReportPoster.isPoster == 1"
          >
          </battle-report>
        </div>
      </battalionPoster>
    </van-popup>
  </div>
</template>

<script>
import img1 from "../../assets/images/winterGame/team_icon.png";
import img2 from "../../assets/images/winterGame/member_icon.png";
import img3 from "../../assets/images/winterGame/achiev_icon.png";
import img3_gray from "../../assets/images/winterGame/achiev_icon_gray.png";
import teamResult from "./components/teamResult.vue";
import schedule from "./components/schedule.vue";
import teamRecordList from "./components/teamRecordList.vue";
import { Toast, Dialog } from "vant";
import {
  queryMatchStatus,
  queryAgentAd,
  teamSchedule,
  teamRecord,
  eventHomePage,
  queryHistoryCup,
  checkAgentMatchSign,
  agentBonus,
  queryZoneInfo,
} from "../../api/winterGame";
import {
  debounce,
  formatDateStr,
  getCupSeason,
  getGameType,
  getHonorDesc,
  getTeamHonorPosterData,
} from "@/util/util";
import titleBar from "@views/WinterGame/components/titleBar.vue";
import shareBtn from "@views/WinterGame/components/shareBtn.vue";
import emptyModule from "@views/WinterGame/components/emptyModule.vue";
import honorModule from "@views/WinterGame/components/honorModule.vue";
import html2canvas from "html2canvas";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import StarMember from "@views/WinterGame/components/poster/starMember.vue";
import TeamHonor from "@views/WinterGame/components/poster/teamHonor.vue";
import BattleReport from "@views/WinterGame/components/poster/battleReport.vue";
import battleReport from "@views/WinterGame/components/poster/battleReport.vue";
import ChangeSeason from "@views/WinterGame/components/changeSeason.vue";
import rankingImg from "@views/WinterGame/components/rankingImg.vue";
import slideDownSelect from "./components/slideDownSelect.vue";
import { gethonorDescMapConfig } from "@/util/config";

export default {
  computed: {
    battleReport() {
      return battleReport;
    },
    shouldShowMatchMsg() {
      return (
        (
          (this.cupStatus === 1 || this.cupStatus === 2 || this.cupStatus === 4) && 
          (this.currentType === 1 || (this.currentType === 2 && this.warStatus == 0))
        ) || (this.warStatus == 1 && !this.teamScheduleData?.schedule_tag_id)
      )
    },
    isSignedUp() {
      return this.info.payStatus === 1;
    },
    hasTeamMembers() {
      return this.info.teamMemberStatus === 1;
    },
    filteredCupName() {
      try {
        if (!this.info?.cupName) return "";
        return this.info.cupName.replace("松鼠杯", "");
      } catch (error) {
        console.error("Error filtering cup name:", error);
        return this.info?.cupName || "";
      }
    },
  },
  data() {
    return {
      padTeamId: 0,
      isShowStarMemberPopUpDialog: false,
      isShowPopUpDialog: false,
      isShowBattleReportPosterPopUpDialog: false,
      honorList: [],
      honorListLength: 0,
      // 战队荣耀 :1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员
      honorDescMap: gethonorDescMapConfig(),
      cupStatus: 0, // 赛季状态 0未开始/1报名期/2比赛中/3已结束/4即是报名期也是比赛期
      campusId: 0,
      agentUserId: 0,
      warStatus: 0, //默认未组队
      isLoading: true, // 添加loading状态控制DOM显示
      blockList: [
        {
          img: img1,
          text: "战队建设",
          url: "/winterGame/createTeam",
        },
        {
          img: img2,
          text: "出战名单",
        },
        {
          img: img3,
          text: "成员战绩",
        },
      ],
      historyList: [],
      historyListOrigin: [], // 未经过滤的历史数据
      historyListWar: [], // 下拉框数据
      bannerList: [
        {
          img: img1,
          text: "战队建设",
          url: "/winterGame/registrationActivities",
        },
        {
          img: img1,
          text: "战队建设",
          url: "/winterGame/registrationActivities",
        },
      ],
      currentType: 1,
      info: {},
      teamScheduleData: null, //战队赛程
      teamRecordData: null, //战队战绩
      teamMemberStatus: 0,
      starMemberPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      teamHonorPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      battleReportPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      teamInfo: {
        teamName: "",
        servicePointName: "",
      },
      starMemberPosterData: null,
      teamHonorPosterData: null,
      battleReportPosterData: null,
      historyTeamInfo: null,
      backImg: "",
      gameType: 0, //用于战队战绩
      gameType2: 0, //用于战队赛程
      // gameTypeHonor: 0,
      honorType: 0,
      knockoutType: 0,
      areaHonorName: "",
      isOut: false,
      signShow: false,
      totalBonus: 0,
      value1: "",
      option1: [
        { text: "全部商品", value: 0 },
        { text: "新款商品", value: 1 },
        { text: "活动商品", value: 2 },
      ],
      currentSeasonLabel: "2024夏季赛",
      drawStatus: -1, // 0-未抽签 1-已抽签 2-抽签已结束
      isDrawed: false,
      drawEndTime: "", // 抽签结束时间
      agentGroupTeamBy: {
        createBy: "",
        createByName: "",
        drawTime: "",
        drawGroupName: "",
      }, // 抽签分配战队
      teamRecordDataLength: 0,
      drawDate: "",
    };
  },
  components: {
    ChangeSeason,
    BattleReport,
    TeamHonor,
    StarMember,
    battalionPoster,
    honorModule,
    emptyModule,
    shareBtn,
    titleBar,
    teamResult,
    schedule,
    rankingImg,
    slideDownSelect,
    teamRecordList,
  },

  mounted() {
    this.initTeamInfo();
    this.setUserInfo();
    if (this.campusId) {
      this.initData();
    }
  },
  methods: {
    toMoreRecord() {
      this.$router.push({
        path: "/winterGame/moreRecord",
        query: {
          campusId: this.campusId,
          agentUserId: this.agentUserId,
          padTeamId: this.padTeamId,
          seasonId: this.info.seasonTagId,
        },
      });
    },
    toDrawLots() {
      this.$router.push({
        path: "/winterGame/draw-lots",
        query: {
          currentCampusId: this.campusId,
          padTeamId: this.padTeamId,
          seasonId: this.info.seasonTagId,
          scheduleId: this.teamScheduleData.schedule_tag_id,
          currentUserId: this.agentUserId,
        },
      });
    },
    async getZoneInfo() {
      let params = {
        param: {
          campusId: this.campusId,
          padTeamId: this.padTeamId,
          seasonId: this.info.seasonTagId,
          scheduleIds: [this.teamScheduleData.schedule_tag_id],
          userId: this.agentUserId,
        },
      };
      let res = await queryZoneInfo(params);
      if (res.code == 0) {
        if (res.data && res.data.length > 0) {
          const { isDrawed, isOverDrawed, drawEndTime, agentGroupTeamBy, drawDate } =
            res.data[0];
          this.isDrawed = isDrawed;
          this.drawDate = drawDate;
          this.drawEndTime = drawEndTime;
          if (this.teamScheduleData.current_war_zone && isDrawed) {
            this.agentGroupTeamBy= {
              createBy: "",
              createByName: "",
              drawTime: "",
              drawGroupName: this.teamScheduleData.current_war_zone,
            }
            this.drawStatus = 3;
            return
          }
          this.agentGroupTeamBy = agentGroupTeamBy;
          if (!isDrawed && !isOverDrawed) {
            // 未开启抽签
            this.drawStatus = -1;
          } else if (isDrawed && isOverDrawed) {
            // 系统自动分配中 展示提示词
            this.drawStatus = 2;
          } else if (isDrawed && !isOverDrawed) {
            // 已开启抽签 引导用户抽签
            this.drawStatus = 0;
          } else if (!isDrawed && isOverDrawed) {
            // 抽签已结束，用户已经抽签
            this.drawStatus = 1;
          }
        }
      } else {
        // Toast(res.message);
      }
    },
    goAlliance() {
      this.$router.push("/winterGame/alliance");
    },
    hideDropList() {
      this.$refs.changeSeason && this.$refs.changeSeason.hideDropList();
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.campusId = userInfoId.campusId;
        this.agentUserId = userInfoId.agentUserId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    async initData() {
      this.isLoading = true; // 控制DOM显示

      // 显示Toast loading
      const loadingToast = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        // 并行执行这些异步操作
        const promises = [
          this.queryMatchStatus(),
          this.queryAgentBonus(),
          this.queryAgentAd(),
        ];

        await Promise.all(promises);

        if (this.teamInfo.cupStatus >= 2) {
          // 赛季状态 0未开始/1报名期/2比赛中/3已结束
          await this.teamSchedule();
          if (this.padTeamId) {
            await this.teamRecord();
          }
          this.eventHomePage();
        }

        await this.queryHistoryCup();
      } catch (error) {
        console.error("数据加载失败:", error);
      } finally {
        // 关闭loading
        loadingToast.clear();
        this.isLoading = false; // 数据加载完成，允许DOM显示
      }
    },
    async queryAgentBonus() {
      let params = {
        param: this.campusId,
      };
      let res = await agentBonus(params);
      if (res.code == 0) {
        if (res.data) {
          this.totalBonus = res.data.bonus_total_amount;
        }
      } else {
        Toast(res.message);
      }
    },
    async queryHistoryCup() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          currentUserId: this.agentUserId,
        },
      };
      let res = await queryHistoryCup(params);
      // res.data[2].isHistoryCup = 1
      if (res.code == 0) {
        if (res.data) {
          this.historyListOrigin = res.data; //原始的历史数据
          let historyListArr = res.data.filter(
            (item) =>
              item.isHistoryCup === 1 && item.cupName.indexOf("季前") == -1
          );
          this.historyList = historyListArr.reverse();
          this.historyList.map((item, index) => {
            item["text"] = item["cupName"];
            item["name"] = item["cupName"];
            item["value"] = item["cupNo"];
            if (index == 0) {
              this.value1 = item["cupNo"];
            }
          });
          let historyListWarArr = res.data.filter(
            (item) => item.isWar === 1 && item.cupName.indexOf("季前") == -1
          );
          this.historyListWar = historyListWarArr.reverse(); //下拉框列表
        }
      } else {
        Toast(res.message);
      }
    },
    async eventHomePage() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          currentUserId: this.agentUserId,
          last_id: 0, //最后一个主建ID，分页用
          page_size: 10,
          scheduleId: "",
          seasonId: "",
        },
      };
      let res = await eventHomePage(params);

      if (res.code === 0) {
        if (res.data) {
          this.honorListLength = res.data.length;
          if (res.data.length > 3) {
            res.data.length = 3;
          }
          res.data.forEach((item) => {
            // item.type = 103; //TODO 强制处理，查看海报效果
            item.item = getHonorDesc(item, this.honorDescMap, this.teamInfo);
            item.day = formatDateStr(item.day);
          });
          this.honorList = res.data;
        }
      } else {
        Toast(res.message);
      }
    },
    async teamSchedule() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          currentUserId: this.agentUserId,
          padTeamId: this.padTeamId,
          scheduleId: "",
          seasonId: "",
        },
      };
      if (!this.padTeamId) {
        return;
      }
      let res = await teamSchedule(params);
      if (res.code == 0) {
        if (res.data) {
          let real_section_start_date = res.data.section_start_date;
          let startDateArr = res.data.section_start_date.split(" ");
          if (Array.isArray(startDateArr)) {
            res.data.section_start_date = startDateArr[0];
          }
          this.isOut = res.data.team_season_end;
          this.teamScheduleData = {
            ...res.data,
            start_date: res.data.section_start_date,
            end_date: res.data.section_end_date,
            ware_zone_a: res.data.war_zone,
            team_id_a: res.data.team_id,
            team_id_b: res.data.vs_team_id,
            status_a: res.data.pk_result_a,
            status_b: res.data.pk_result_b,
            game_status: res.data.status,
            real_section_start_date: real_section_start_date,
            current_war_zone: res.data.war_zone,
          };
          this.gameType2 = getGameType(this.teamScheduleData.schedule_tag_id);
          this.getZoneInfo();
        }
      } else {
        // Toast(res.message);
      }
    },
    async teamRecord() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          currentUserId: this.agentUserId,
          padTeamId: this.padTeamId,
          scheduleId: "",
          seasonId: "",
        },
      };
      let res = await teamRecord(params);
      if (res.code == 0) {
        // 统一为数组
        let arr = Array.isArray(res.data)
          ? res.data
          : res.data
          ? [res.data]
          : [];
        this.teamRecordData = arr.slice(0, 2);
        this.teamRecordDataLength = arr.length;
      } else {
        Toast(res.message);
      }
    },
    async queryMatchStatus() {
      let params = {
        param: {
          campusId: this.campusId,
        },
      };
      let res = await queryMatchStatus(params);
      if (res.code == 0) {
        let data = res.data;
        this.info = data;
        this.cupStatus = data.cupStatus; //=2;
        this.warStatus = data.warStatus; // =1;
        this.teamMemberStatus = data.teamMemberStatus;
        localStorage.setItem("serviceName", data.servicePointName);
        if (data.signStartDate && data.signEndDate) {
          let signStartDay = data.signStartDate.substring(0, 10).replace(/-/g, "");
          let signEndDay = data.signEndDate.substring(0, 10).replace(/-/g, "");
          let signDay = this.getDay();
          if (signDay >= signStartDay && signDay <= signEndDay) {
            // 比赛期间
            this.signShow = true;
          } else {
            this.signShow = false;
          }
        }
        if (this.cupStatus == 2 || this.cupStatus == 4) {
          this.signShow = true;
        }
        if (data.payStatus == 0) {
          // 未报名
          this.currentType = 1;
          if (this.teamMemberStatus !== 1) {
            this.currentType = 2;
          }
        } else {
          // 已报名
          this.currentType = 2;
        }
      } else {
        Toast(res.message);
      }
    },
    getDay(d) {
      var d = new Date();
      var year = d.getFullYear();
      var month =
        d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
      var day = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
      return year + "" + month + "" + day;
    },
    async queryAgentAd() {
      let params = {
        param: {
          adType: 10, //松鼠杯类型
          agentId: this.campusId,
        },
      };
      let res = await queryAgentAd(params);

      if (res.code == 0) {
        this.bannerList = res.data;
      } else {
        Toast(res.message);
      }
    },
    async checkAgentMatchSign() {
      let params = {
        param: {
          currentCampusId: this.campusId,
          seasonId: JSON.parse(localStorage.getItem("pkParams")).seasonId,
          openId: "",
        },
      };
      let res = await checkAgentMatchSign(params);
      if (res.code == 0) {
        this.toMembers();
      } else {
        this.$toast(res.message);
      }
    },
    handleClick(item) {
      if (item.text == "战队建设") {
        if (this.info.teamId == 0) {
          this.$router.push(item.url);
        } else {
          if (this.info.teamMemberStatus == 1) {
            wx.miniProgram.navigateTo({
              url: "/subpackages/home/winterGame/myTeamMembers/index",
            });
          } else {
            wx.miniProgram.navigateTo({
              url: "/subpackages/home/winterGame/createTeamSuc/index",
            });
          }
        }
      }
      if (item.text == "出战名单") {
        if (this.info.teamId == 0) {
          Toast("战队未建设");
        } else {
          this.checkAgentMatchSign();
          /*if(this.info.teamMemberStatus == 0)
                    {
                        // Toast('请先添加战队成员')
                        wx.miniProgram.navigateTo({url: '/subpackages/home/winterGame/myTeamMembers/index'})
                    }else{
                        wx.miniProgram.navigateTo({url: `/subpackages/home/winterGame/addTeamMembers/index?teamId=${this.info.teamId}`})
                    }*/
        }
      }
      if (item.text == "成员战绩") {
        // Toast("建设中，敬请期待");
        if (this.teamInfo.cupStatus == 0) {
          return;
        }
        this.$router.push("/winterGame/studentAchievement");
      }

      // this.$router.push(item.url)
    },
    handleBonus(item) {
      if (item == "get") {
        this.$router.push("/winterGame/bonusRules");
      }
      if (item == "look") {
        this.$router.push({
          path: "/winterGame/bonusDetail",
          query: {
            teamName: this.info.teamName,
            servicePointName: this.info.servicePointName,
            campusId: this.campusId,
          },
        });
      }
    },
    toDetail(item) {
      wx.miniProgram.navigateTo({ url: item.route });
    },
    test () {
      wx.miniProgram.navigateTo({ url: '/subpackages/home/squirrelCup/signUp/index?year=2025&season=summer' });
    },
    toMembers() {
      if (this.info.teamMemberStatus == 0) {
        // Toast('请先添加战队成员')
        Dialog.confirm({
          title: "错误",
          confirmButtonText: "去添加",
          message: "暂无战队成员，请先添加战队成员",
        })
          .then(() => {
            // on confirm
            wx.miniProgram.navigateTo({
              url: `/subpackages/home/winterGame/myTeamMembers/index?scheduleId=${this.teamScheduleData.schedule_tag_id}&seasonId=${this.info.seasonTagId}`,
            });
          })
          .catch(() => {
            // on cancel
          });
        // wx.miniProgram.navigateTo({url: '/subpackages/home/winterGame/myTeamMembers/index'})
      } else {
        wx.miniProgram.navigateTo({
          url: `/subpackages/home/winterGame/addTeamMembers/index?teamId=${this.info.teamId}&scheduleId=${this.teamScheduleData.schedule_tag_id}&seasonId=${this.info.seasonTagId}`,
        });
      }
    },
    toHistoryResult(item) {
      const {
        scheduleId,
        seasonId,
        cupName,
        teamName = "天之蓝2",
        servicePointName = "上海服务中心2",
        teamId,
      } = item;
      let [cupYear, cupSeason, cupYearSeason] = getCupSeason(
        item.title || "2023_spring"
      );

      this.historyTeamInfo = {
        teamId,
        scheduleId,
        seasonId,
        teamName,
        cupName,
        cupStatus: 3, // 已结果
        servicePointName,
        warStatus: 1, // '出战状态1出战0未出战'
        teamMemberStatus: 1, // '是否有战队成员1 有0没有'
        payStatus: 1, // '报名状态1报名0未报名'
        cupYear,
        cupSeason,
        cupYearSeason,
      };
      localStorage.setItem(
        "historyTeamInfo",
        JSON.stringify(this.historyTeamInfo)
      );
      this.$router.push({
        path: "/winterGame/historyResult",
        query: { scheduleId, seasonId },
      });
    },
    getWinNum(wining_num) {
      let text = "";
      switch (wining_num) {
        case 3:
          text = "三";
          break;
        case 4:
          text = "四";
          break;
        case 5:
          text = "五";
          break;
        case 6:
          text = "六";
          break;
        case 7:
          text = "七";
          break;
        case 8:
          text = "八";
          break;
        case 9:
          text = "九";
          break;
      }
      return text;
    },
    shareClick(data) {
      // 1最强战队2连胜战队3最精彩的比赛4满勤战队5最强战队（赛季）6冠军战队7亚军战队8季军战队9战队MVP学员10战区单日最强战队
      if (data.type == 9) {
        // 9战队MVP学员
        this.starMemberPosterData = {
          realName: data.honorDesc.userName,
          cupNumber: data.honorDesc.cupNumber,
          date: data.day,
        };
        // 明星学员海报
        this.lookStarMemberPoster();
      } else {
        // 通用海报
        this.teamHonorPosterData = getTeamHonorPosterData(data, this.teamInfo);
        this.lookTeamHonorPoster();
      }
    },
    handleCancelStarMemberPoster(type) {
      this.starMemberPoster.isShow = type;
      this.isShowStarMemberPopUpDialog = false;
      this.$toast.clear(); // 清除当前 Toast
    },
    handleCancelTeamHonorPoster(type) {
      this.teamHonorPoster.isShow = type;
      this.isShowPopUpDialog = false;
      this.$toast.clear(); // 清除当前 Toast
    },
    handleCancelBattleReportPoster(type) {
      this.battleReportPoster.isShow = type;
      this.isShowBattleReportPosterPopUpDialog = false;
      this.$toast.clear(); // 清除当前 Toast
    },
    // 查看团队荣誉海报
    lookTeamHonorPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.teamHonorPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
      setTimeout(() => {
        const targetDom = document.querySelector("#teamHonorPosterContainer");
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.teamHonorPoster.isShow = true;
          this.teamHonorPoster.posterUrl = canvas.toDataURL();
          this.teamHonorPoster.isPoster = -1;
          Toast("长按保存图片");
        });
      }, 500);
    },
    lookStarMemberPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowStarMemberPopUpDialog = true;
      this.starMemberPoster.isPoster = 1;
      setTimeout(() => {
        const targetDom = document.querySelector("#starMemberPosterContainer");
        // const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.starMemberPoster.isShow = true;
          this.starMemberPoster.posterUrl = canvas.toDataURL();
          this.starMemberPoster.isPoster = -1;
          Toast("长按保存图片");
          // gio("track", "onShareBattleReport", { onSharePosters: "ShareLogo" });
        });
      }, 500);
    },
    lookBattleReportPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowBattleReportPosterPopUpDialog = true;
      this.battleReportPoster.isPoster = 1;
      setTimeout(() => {
        const dom = document.querySelector("#battleReportPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.battleReportPoster.isShow = true;
          this.battleReportPoster.posterUrl = canvas.toDataURL();
          this.battleReportPoster.isPoster = -1;
          Toast("长按保存图片");
        });
      }, 500);
    },
    initTeamInfo() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
      this.padTeamId = this.teamInfo.padTeamId;
      //this.teamInfo = {cupStatus:0,"teamName":"天之蓝新","cupName":"松鼠杯2023春季赛","cupStartDate":"2023-04-16","cupEndDate":"2023-05-10","servicePointName":"上海浦江中心2号服务中心新","warStatus":1,"teamMemberStatus":1,"payStatus":1}

      if (this.teamInfo.cupStatus == 0) {
        this.blockList = [
          {
            img: img1,
            text: "战队建设",
            url: "/winterGame/createTeam",
          },
          {
            img: img2,
            text: "出战名单",
          },
          {
            img: img3_gray,
            text: "成员战绩",
          },
        ];
      }
    },
    // 切换赛程
    changeSchedule(value) {
      for (let i = 0; i < this.historyList.length; i++) {
        let item = this.historyList[i];
        if (item.value == value) {
          this.toHistoryResult(item);
          break;
        }
      }
    },
    seasonChange(selectdata) {
      this.toHistoryResult(selectdata.item);
    },
  },
};
</script>

<style lang="less" scoped>
.main-wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding: 46px 32px;

  .van-swipe-item img {
    max-width: 100%;
  }

  .list {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    color: #323232;
    line-height: 44px;

    .item {
      min-width: 218px;
      text-align: center;
      margin-bottom: 16px;

      p {
        margin: 0;
      }

      img {
        width: 96px;
        height: 96px;
        margin-bottom: 10px;
      }
    }
  }

  .guide-wrap {
    font-size: 32px;
    color: #58abf6;
    line-height: 44px;

    img {
      width: 112px;
      margin-left: 98px;
      margin-bottom: 6px;
    }

    p {
      margin: 0;
      text-align: center;
    }
  }

  .bonus-wrap {
    position: relative;
    width: 100%;
    padding: 0 16px;

    img {
      width: 100%;
    }

    .bonus-left {
      position: absolute;
      top: 0;
      left: 20px;
      width: 200px;
      height: 60px;
    }

    .bonus-right {
      position: absolute;
      top: 0;
      right: 20px;
      width: 180px;
      height: 60px;
      line-height: 54px;
      font-size: 24px;
      color: #ffede7;
      text-align: center;
    }

    .totalBonusNum {
      position: absolute;
      width: 100%;
      height: 130px;
      line-height: 130px;
      text-align: center;
      left: -10px;
      bottom: 20px;
      font-size: 64px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #c32200;
    }

    .totalLongBonusNum {
      position: absolute;
      width: 100%;
      height: 130px;
      line-height: 130px;
      text-align: center;
      left: -10px;
      bottom: 20px;
      font-size: 52px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #c32200;
    }
  }

  .team-msg {
    margin: 80px 0 20px;
    text-align: center;

    div {
      font-size: 28px;
      color: #68707d;
      line-height: 40px;
    }

    .team-name {
      font-size: 40px;
      font-weight: 600;
      color: #323232;
      line-height: 56px;
      margin-bottom: 8px;
    }
  }

  .math-period {
    width: 280px;
    height: 56px;
    margin: 16px auto 32px;
    background: #e4f1fd;
    border-radius: 34px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #58abf6;
    line-height: 56px;
    text-align: center;
    font-style: normal;
  }

  .switch-season {
    position: relative;
    width: 280px;
    height: 56px;
    margin: 0 auto 30px;
    background: #e4f1fd;
    border-radius: 34px;
    z-index: 10;

    /deep/.slideDownSelect {
      h3 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #58abf6;
        line-height: 40px;
        text-align: left;
        font-style: normal;
      }
    }
  }

  .match-msg {
    position: relative;
    font-size: 40px;
    font-weight: 600;
    color: #ffffff;
    line-height: 72px;
    text-align: center;

    .signOk {
      text-align: center;
      margin-top: 40px;

      .titleBar {
        margin-bottom: 20px;
      }

      img {
        width: 260px;
        height: 256px;
      }

      p {
        height: 66px;
        font-size: 48px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        line-height: 66px;
        margin-top: 24px;
        text-align: center;
        margin-bottom: 0;
      }
    }
    .new_old_union_entry {
      margin-top: 20px;
    }

    .name {
      position: relative;
    }

    .red {
      position: absolute;
      left: 50px;
      width: 320px;
      height: 68px;
      background: linear-gradient(270deg, #df2249 0%, #f24e56 100%);
      border-radius: 2px;
      transform: skewX(-25deg);
    }

    .blue {
      position: absolute;
      right: 50px;
      top: 4px;
      width: 320px;
      height: 68px;
      background: linear-gradient(
        270deg,
        #37a0ff 0%,
        rgba(67, 131, 235, 0.9) 100%
      );
      border-radius: 2px;
      transform: skewX(-25deg);
    }

    .status {
      // height: 40px;
      margin-top: 24px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #68707d;
      line-height: 40px;

      .view-member {
        color: #58abf6;
        text-decoration: underline;
      }
      .ok-img {
        width: 260px;
        height: 256px;
        margin: 0 auto 24px;
        display: block;
      }
      .ok-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 48px;
        color: #323232;
        line-height: 66px;
        text-align: center;
        font-style: normal;
      }
      &.ok-status {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    .recent-schedule {
      position: relative;
      width: 622px;
      height: 468px;
      margin: 24px auto;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.2);
      border-radius: 8px;

      div.bar {
        position: absolute;
        top: 8px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;

        span {
          display: inline-block;

          width: 16px;
          height: 14px;
          background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);

          &:first-child {
            margin-left: -16px;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
          }

          &:last-child {
            margin-right: -16px;
            border-top-right-radius: 7px;
            border-bottom-right-radius: 7px;
          }
        }
      }

      .schedule-header {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 48px;

        > img:first-child {
          display: block;
          width: 32px;
          height: 24px;
          margin-right: 10px;
        }

        > img:last-child {
          display: block;
          width: 32px;
          height: 24px;
          margin-left: 10px;
        }

        .schedule-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 48px;
          color: #323232;
          line-height: 66px;
          text-align: center;
          font-style: normal;
        }
      }

      .schedule-time {
        width: 100%;
        height: 96px;
        margin-top: 40px;
        background: #e4f1fd;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 40px;
        color: #323232;
        line-height: 56px;
        text-align: center;
        font-style: normal;
        line-height: 96px;
      }

      .schedule-status {
        margin-top: 64px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 48px;
        color: #323232;
        line-height: 66px;
        text-align: center;
        font-style: normal;
        text-align: center;
      }
    }
  }

  .sign-up-msg {
    margin-top: 16px;
    text-align: center;
    font-size: 28px;
    color: #68707d;
    line-height: 40px;

    span {
      color: #58abf6;
      text-decoration: underline;
    }
  }

  .banner {
    margin-top: 48px;

    .van-swipe-item {
      text-align: center;
    }
  }

  .spring_2025 {
    margin: 50px 0 50px;
  }

  .summer_2025 {
    margin: 50px 0 90px;
  }

  .history-msg {
    margin: 80px 16px 0;

    .title {
      font-size: 40px;
      font-weight: 600;
      color: #323232;
      line-height: 56px;
      margin-bottom: 40px;
    }

    .item {
      font-size: 32px;
      color: #323232;
      line-height: 44px;
      margin-bottom: 32px;
      margin-left: 24px;

      .van-icon {
        margin-left: 64px;
      }
    }
  }

  .gameTitle {
    width: 280px;
    height: 56px;
    background: #e4f1fd;
    border-radius: 34px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #58abf6;
    line-height: 56px;
    margin: auto auto 40px;
    text-align: center;
  }

  .myTeamRecord {
    margin-top: 20px;

    & > section {
      margin-bottom: 40px;

      & > header {
        margin-bottom: 16px;
      }

      .list {
        display: block;
      }

      div.bar {
        position: absolute;
        top: 8px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;

        span {
          display: inline-block;

          width: 16px;
          height: 14px;
          background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);

          &:first-child {
            margin-left: -16px;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
          }

          &:last-child {
            margin-right: -16px;
            border-top-right-radius: 7px;
            border-bottom-right-radius: 7px;
          }
        }
      }

      footer {
        width: 622px;
        margin: 0 auto;
        margin-top: 24px;
        text-align: right;
        position: relative;

        .more {
          width: 242px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #58abf6;
          line-height: 40px;
        }
      }

      .rank-data {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .data-num {
            font-size: 48px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            margin: 0 0 8px 0;
            padding: 0;
          }

          .describe {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #68707d;
            margin: 0 0 32px 0;
            padding: 0;
          }
        }
      }

      .order {
        width: 70%;
        height: 306px;
        background: url("../../assets/images/winterGame/orderBg.png") no-repeat;
        background-size: 100%;
        background-position: center;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        h3 {
          position: absolute;
          top: 10px;
          left: calc(50% - 104);
          width: 208px;
          height: 46px;
          background: rgba(88, 171, 246, 0.16);
          border-radius: 24px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #619cf5;
          line-height: 46px;
          text-align: center;
        }

        .text {
          color: #ffffff;
          text-shadow: 0px 0px 16px #ae7000;
          font-size: 48px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-top: 40px;

          label {
            font-size: 58px;
            line-height: 50px;
          }

          .title-tag {
            width: 176px;
            background: #d5862f;
            border-radius: 20px;
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
            // position: absolute;
            // top: -25px;
          }

          p {
            margin: 0;
            position: relative;
            // margin-top: 60px;
          }
        }

        .promote-img {
          position: absolute;
          bottom: 0;
          right: -90px;
          width: 156px;
          height: 156px;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }

      .promote-img {
        position: absolute;
        top: 120px;
        right: 0px;
        width: 156px;
        height: 156px;

        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #58abf6;
}

.van-dialog {
  border-radius: 0.8em;
}

.van-dialog__message {
  height: 4rem;
}

.van-dialog__cancel,
.van-dialog__confirm {
  height: 4rem;
}
</style>

<style lang="less">
.van-dropdown-menu__bar {
  width: 380px;
  height: 56px;
  margin: 0 auto;
  background: #e4f1fd;
  border-radius: 34px;

  .van-dropdown-menu__item {
    .van-ellipsis {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #58abf6;
      line-height: 40px;
      text-align: left;
      font-style: normal;
    }
  }
}

.van-dropdown-menu__title::after {
  border-color: transparent transparent #1989fa #1989fa;
}
</style>
